export const mediumTypeText = (values) => {
   if (Array.isArray(values) && values.length > 1) {
     return values.length + "_types"
   } else if (Array.isArray(values) && values.length === 1) {
     return values[0]
   } else {
     return ''
   }
}

export const productSystemText = (value) => {
   if (value !== '' && value !== undefined) {
     return "all"
   } else {
     return ''
   }
}

export const currentLang = () => {
  return localStorage.getItem('i18nextLng') || 'de'
}

export const slugify = (string) => {
  const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/,:;'
  const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz_____'
  const p = new RegExp(a.split('').join('|'), 'g')
  string = string || ""

  return string.toString().toLowerCase()
    .replace(/\s+/g, '_') // Replace spaces with underscore
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '_and_') // Replace & with 'and'
    .replace(/[^\W]+/g, '') // Remove all non-word characters
    .replace(/-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}

export const availableCountries = ["af", "al", "dz", "ad", "ao", "ag", "ar", "am", "au", "at", "az", "bs", "bh", "bd", "bb", "by", "be", "bz", "bj", "bt",
 "bo", "ba", "bw", "br", "bn", "bg", "bf", "bi", "cv", "kh", "cm", "ca", "cf", "td", "cl", "cn", "co", "km", "cg", "cd",
 "cr", "ci", "hr", "cu", "cy", "cz", "dk", "dj", "dm", "do", "ec", "eg", "sv", "gq", "er", "ee", "sz", "et", "fj", "fi",
 "fr", "ga", "gm", "ge", "de", "gh", "gr", "gd", "gt", "gn", "gw", "gy", "ht", "hn", "hu", "is", "in", "id", "ir", "iq",
 "ie", "il", "it", "jm", "jp", "jo", "kz", "ke", "ki", "kp", "kr", "kw", "kg", "la", "lv", "lb", "ls", "lr", "ly", "li",
 "lt", "lu", "mg", "mw", "my", "mv", "ml", "mt", "mh", "mr", "mu", "mx", "fm", "md", "mc", "mn", "me", "ma", "mz", "mm",
 "na", "nr", "np", "nl", "nz", "ni", "ne", "ng", "mk", "no", "om", "pk", "pw", "pa", "pg", "py", "pe", "ph", "pl", "pt",
 "qa", "ro", "ru", "rw", "kn", "lc", "vc", "ws", "sm", "st", "sa", "sn", "rs", "sc", "sl", "sg", "sk", "si", "sb", "so",
 "za", "ss", "es", "lk", "sd", "sr", "se", "ch", "sy", "tj", "tz", "th", "tl", "tg", "to", "tt", "tn", "tr", "tm", "tv",
 "ug", "ua", "ae", "gb", "us", "uy", "uz", "vu", "ve", "vn", "ye", "zm", "zw"];

export const availableContactTypes = ["architekt", "generalunternehmer", "haendler", "haustechnik", "verarbeiter", "gutachter", "sonstiges"]

export const availableHoleForms = ["none", "square", "circle"]

export const availableMediumTypesCables = ['ke', 'kb', 'kt', 'e', 'ls'];

export const availableMediumTypesTubes = ['r', 'rn', 'a', 'ls', 'lue_r', 'lue_e'];



// WEBPACK FOOTER //
// ./src/store/actions/support.js